import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export type DiscardChangesModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
}

export const DiscardChangesModal: React.FC<DiscardChangesModalProps> = ({
  open,
  onOpenChange,
  onDiscard,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]" hideCloseButton>
        <DialogHeader>
          <DialogTitle className="m-0 text-lg font-semibold text-gray-light-900">
            {t('notificationSettings.discardModal.title')}
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-light-600">
            {t('notificationSettings.discardModal.description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-3 mt-3 sm:gap-3">
          <Button
            variant="outlined"
            onClick={() => onOpenChange(false)}
            className="flex-1 h-10 text-sm font-semibold sm:flex-1"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={onDiscard}
            className="flex-1 h-10 text-sm font-semibold bg-error-600 hover:bg-error-700 sm:flex-1"
          >
            {t('notificationSettings.discardModal.discard')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
